var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmuglergods(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "4000.000000pt",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 4000.000000 4000.000000",
    width: "4000.000000pt",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    stroke: "none",
    transform: "translate(0.000000,4000.000000) scale(0.100000,-0.100000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33270 22686 c0 -34 92 -135 418 -459 209 -208 387 -393 396 -411 9 -19 16 -52 16 -75 0 -23 4 -41 8 -41 4 0 26 18 47 40 l39 40 -404 406 c-379 379 -520 515 -520 500z",
    stroke: "#000000",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18155 20790 l-1360 -1360 -642 0 c-473 0 -644 -3 -649 -12 -10 -16 21 -36 86 -56 49 -15 113 -17 575 -17 462 0 527 2 582 17 134 37 234 108 300 211 36 56 232 260 907 937 489 491 889 901 925 948 35 45 100 115 145 154 129 115 446 430 462 460 16 30 35 78 31 78 -1 0 -614 -612 -1362 -1360z",
    stroke: "#000000",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34343 20548 l-1113 -1113 -1467 -5 c-1125 -4 -1467 -8 -1470 -17 -9 -26 77 -55 191 -65 64 -5 646 -7 1376 -5 1159 3 1270 5 1329 20 135 36 227 109 356 281 201 268 495 562 761 763 99 75 132 107 194 189 44 58 200 226 380 409 356 362 618 655 584 655 -5 0 -509 -501 -1121 -1112z",
    stroke: "#000000",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7205 21420 l-59 -60 76 0 c110 0 113 2 81 59 -14 25 -29 49 -33 53 -3 4 -32 -19 -65 -52z",
    stroke: "#000000",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23685 21420 l-59 -60 79 1 c44 0 88 4 98 8 18 6 18 8 2 21 -9 7 -25 31 -36 52 -11 21 -21 38 -22 38 -1 0 -29 -27 -62 -60z",
    stroke: "#000000",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18714 21138 c-44 -39 -392 -383 -774 -763 -382 -380 -707 -697 -722 -705 -54 -26 -45 9 20 83 28 33 23 30 -20 -12 -68 -65 -136 -171 -105 -163 17 4 19 1 15 -23 -4 -21 200 179 833 811 462 461 839 840 839 841 0 9 -16 -4 -86 -69z",
    stroke: "#000000",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5235 21068 l-126 -121 -167 2 c-95 1 -178 -2 -192 -8 -17 -6 -19 -10 -8 -10 26 -1 68 -23 68 -35 0 -8 -177 -10 -617 -8 l-618 3 -47 25 c-26 13 -53 24 -60 24 -7 -1 -44 -30 -82 -65 l-68 -65 771 0 c466 0 771 4 771 9 0 17 104 60 173 72 78 13 102 27 238 145 90 77 99 88 99 120 0 18 -2 34 -5 34 -2 0 -61 -55 -130 -122z",
    stroke: "#000000",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15570 19825 l-1365 -1365 -1443 0 c-1403 0 -1442 -1 -1433 -19 6 -10 23 -27 38 -37 27 -18 72 -19 1362 -22 849 -1 1354 1 1388 8 30 5 71 17 91 26 23 11 202 181 482 459 449 445 488 482 615 570 81 56 97 72 131 140 20 38 205 229 765 790 659 661 740 745 746 778 3 20 2 37 -3 37 -5 0 -623 -614 -1374 -1365z",
    stroke: "#000000",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24715 20790 l-400 -400 -642 0 c-412 0 -643 -4 -643 -10 0 -18 52 -44 114 -57 44 -9 177 -13 481 -12 388 0 430 2 556 22 l136 23 114 96 c63 53 244 226 402 385 270 271 288 292 285 322 -3 30 -16 18 -403 -369z",
    stroke: "#000000",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9400 20305 l-875 -875 -639 -2 c-485 -2 -640 -6 -643 -15 -3 -7 15 -22 38 -34 66 -33 215 -41 704 -36 368 3 449 7 498 20 138 40 218 102 348 272 71 93 245 273 760 790 567 569 669 676 678 709 6 22 9 41 8 43 -2 1 -396 -391 -877 -872z",
    stroke: "#000000",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21225 20580 l-600 -600 -240 -1 c-154 -1 -216 -4 -173 -9 64 -6 121 -34 101 -49 -5 -4 -287 -4 -628 -1 l-620 5 -35 22 c-19 13 -44 23 -55 23 -12 0 -48 -27 -85 -65 l-65 -65 765 2 765 3 28 22 c32 25 95 47 184 64 53 10 74 21 145 77 92 73 1053 1025 1094 1083 16 23 24 47 22 63 -3 23 -71 -42 -603 -574z",
    stroke: "#000000",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27005 19820 l-1360 -1360 -1443 0 c-1403 0 -1442 -1 -1433 -19 6 -10 23 -27 38 -37 27 -18 72 -19 1362 -22 849 -1 1354 1 1388 8 30 5 71 17 91 26 23 11 210 189 502 479 344 342 488 478 555 525 117 82 139 103 187 175 25 36 319 339 728 750 377 380 698 706 712 725 25 34 53 110 40 110 -4 0 -619 -612 -1367 -1360z",
    stroke: "#000000",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38170 21063 l-122 -117 -166 3 c-97 1 -178 -2 -192 -8 -17 -6 -19 -10 -8 -10 26 -1 68 -23 68 -35 0 -8 -177 -10 -617 -8 l-618 3 -47 25 c-26 13 -53 24 -60 24 -7 -1 -44 -30 -82 -65 l-68 -65 770 0 c507 0 773 3 777 10 11 18 65 41 147 61 45 11 100 30 122 41 46 24 158 127 186 173 20 33 42 85 35 85 -2 0 -59 -53 -125 -117z",
    stroke: "#000000",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11251 20506 l-664 -664 139 5 c121 5 142 8 159 25 20 20 20 20 -12 13 -65 -13 -94 37 -59 103 8 15 254 266 546 557 292 292 537 541 544 555 20 37 29 70 19 70 -4 0 -307 -299 -672 -664z",
    stroke: "#000000",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12705 20300 l-870 -870 -1469 -2 c-1130 -2 -1470 -6 -1473 -15 -8 -24 77 -55 176 -64 128 -11 2470 -11 2588 0 62 6 111 18 146 34 58 26 328 251 348 289 6 13 321 334 699 713 470 471 695 704 710 733 12 24 20 46 18 48 -2 2 -395 -388 -873 -866z",
    stroke: "#000000",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30785 20300 l-870 -870 -1469 -2 c-1130 -2 -1470 -6 -1473 -15 -8 -24 74 -53 179 -64 67 -6 554 -9 1383 -6 1394 3 1325 0 1441 60 86 44 159 112 250 234 71 96 209 240 750 783 456 457 668 677 679 702 17 42 18 48 7 48 -4 0 -399 -391 -877 -870z",
    stroke: "#000000",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5430 21064 c-68 -42 -83 -43 -74 -6 6 23 -6 15 -78 -53 -58 -55 -80 -81 -69 -83 32 -8 33 -22 2 -79 -31 -57 -29 -55 124 97 85 85 155 156 155 157 0 4 -1 4 -60 -33z",
    stroke: "#000000",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16954 21013 c-69 -54 -311 -288 -659 -635 -303 -301 -555 -548 -560 -548 -5 0 240 251 546 558 305 306 576 586 603 622 29 38 -240 -224 -653 -635 -385 -385 -701 -704 -701 -709 0 -5 -18 -35 -41 -68 -22 -33 -35 -57 -28 -53 7 5 17 1 24 -8 10 -13 129 102 801 774 434 434 786 789 783 789 -3 0 -55 -39 -115 -87z",
    stroke: "#000000",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25155 21045 c-43 -30 -81 -53 -83 -50 -2 2 6 20 18 40 12 20 21 38 18 40 -2 2 -163 -156 -359 -351 -275 -274 -350 -354 -332 -354 27 0 30 -21 8 -64 -9 -16 -14 -30 -12 -32 1 -2 189 183 417 411 228 228 412 415 409 415 -3 0 -41 -25 -84 -55z",
    stroke: "#000000",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21417 20562 c-260 -257 -507 -498 -550 -536 -43 -38 -96 -96 -119 -130 -30 -45 114 94 556 534 328 327 596 596 596 597 0 12 -68 -54 -483 -465z",
    stroke: "#000000",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5973 20188 l-758 -758 -640 0 c-360 0 -646 -4 -654 -9 -11 -7 -7 -14 19 -30 72 -44 107 -46 650 -46 461 0 522 2 579 18 135 37 241 121 358 281 100 138 1184 1216 1222 1216 8 0 6 -10 -3 -29 -14 -27 -14 -29 4 -34 23 -6 26 -37 8 -70 -15 -29 65 39 165 140 l78 79 -136 0 -135 -1 -757 -757z",
    stroke: "#000000",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7623 20188 l-758 -758 -630 0 c-346 0 -636 -4 -643 -8 -10 -7 -8 -12 5 -24 60 -52 171 -61 722 -55 475 5 503 7 606 57 78 38 158 113 254 237 68 90 204 231 563 588 457 454 635 626 657 633 17 6 13 -19 -6 -40 -15 -17 -15 -18 4 -18 29 0 35 -25 18 -66 -12 -29 5 -16 110 83 69 65 125 120 125 123 0 3 -61 5 -135 5 l-135 0 -757 -757z",
    stroke: "#000000",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14488 20392 l-553 -553 135 7 c126 6 137 8 160 31 23 23 23 24 3 14 -32 -16 -58 -13 -78 9 -16 18 -17 25 -6 60 9 32 70 97 334 358 177 175 367 359 422 409 55 50 109 100 119 112 11 11 26 21 34 21 12 0 12 -4 -2 -25 -20 -31 -20 -32 4 -38 23 -6 26 -36 8 -70 -14 -27 81 55 175 150 l68 69 -136 0 -135 -1 -552 -553z",
    stroke: "#000000",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19658 20673 l-273 -273 136 0 c119 0 138 2 152 18 24 26 21 33 -8 22 -42 -16 -75 3 -75 42 0 47 27 85 120 169 46 41 116 104 156 142 67 62 94 79 94 59 0 -4 -7 -17 -15 -29 -13 -19 -13 -21 7 -26 18 -5 20 -11 15 -41 -3 -20 -3 -36 1 -36 4 0 58 51 120 113 l112 112 -135 0 -135 0 -272 -272z",
    stroke: "#000000",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22453 20188 l-758 -758 -635 0 c-349 0 -641 -4 -648 -8 -19 -12 16 -40 75 -59 40 -13 124 -17 498 -20 482 -5 623 2 699 36 35 15 149 123 498 474 338 338 479 472 553 527 127 93 151 115 240 225 79 98 236 255 254 255 15 0 14 -11 -4 -37 -13 -19 -13 -21 5 -26 22 -6 26 -36 10 -68 -22 -40 9 -15 123 99 l117 117 -135 0 -135 0 -757 -757z",
    stroke: "#000000",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25928 20392 l-553 -553 135 7 c126 6 137 8 160 31 23 23 23 24 3 14 -32 -16 -58 -13 -78 9 -16 18 -17 25 -6 60 9 32 70 97 334 358 177 175 367 359 422 409 55 50 109 100 119 112 11 11 26 21 34 21 12 0 12 -4 -2 -25 -20 -31 -20 -32 4 -38 23 -6 26 -36 8 -70 -14 -27 81 55 175 150 l68 69 -136 0 -135 -1 -552 -553z",
    stroke: "#000000",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29228 20396 c-302 -301 -548 -550 -548 -552 0 -3 60 -2 133 2 122 6 134 8 157 31 l25 24 -30 -11 c-72 -27 -106 24 -64 96 23 40 609 622 798 793 84 76 122 97 94 52 -9 -14 -7 -20 8 -29 21 -14 24 -43 8 -75 -12 -23 26 10 159 138 39 38 72 72 72 75 0 3 -60 5 -132 5 l-133 0 -547 -549z",
    stroke: "#000000",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32538 20391 l-553 -553 79 6 c43 3 107 6 142 6 52 0 65 3 74 19 9 18 7 19 -23 14 -24 -4 -37 0 -51 16 -17 19 -18 26 -7 60 9 32 71 99 334 359 288 285 482 470 552 526 30 24 41 16 23 -14 -11 -18 -11 -22 5 -31 20 -11 22 -41 6 -72 -18 -32 49 24 154 130 l88 89 -136 0 -135 -1 -552 -554z",
    stroke: "#000000",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4200 20035 l-606 -605 -1435 0 c-790 0 -1438 -3 -1442 -6 -11 -11 5 -34 41 -56 l37 -23 1340 0 c1254 0 1345 1 1416 18 131 31 255 120 305 219 20 42 128 155 495 523 424 425 469 474 469 503 0 18 -3 32 -7 32 -4 0 -279 -272 -613 -605z",
    stroke: "#000000",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37137 20032 l-603 -602 -1459 0 c-803 0 -1466 -4 -1473 -9 -11 -6 -7 -13 15 -29 67 -47 31 -46 1378 -50 1376 -3 1462 -1 1544 43 66 37 1160 1132 1191 1193 12 24 19 47 16 50 -4 3 -277 -265 -609 -596z",
    stroke: "#000000",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4825 20463 c-61 -48 -234 -210 -386 -360 -151 -150 -279 -273 -284 -273 -5 0 117 127 271 283 153 155 301 311 328 347 30 40 -112 -96 -378 -360 -234 -234 -426 -429 -426 -434 0 -5 -18 -35 -40 -67 -45 -66 -46 -69 -26 -69 8 0 16 -5 18 -10 2 -6 237 224 523 510 286 286 517 520 515 520 -3 0 -55 -39 -115 -87z",
    stroke: "#000000",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2418 20393 c-432 -2 -738 -7 -738 -12 0 -20 62 -60 103 -66 47 -7 900 2 1044 11 128 8 152 -6 165 -91 3 -16 19 -5 91 64 77 74 103 106 80 99 -5 -2 -340 -4 -745 -5z",
    stroke: "#000000",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35328 20393 c-454 -2 -768 -7 -768 -12 0 -19 67 -50 131 -61 66 -11 870 -7 1076 6 128 8 152 -6 165 -91 3 -16 19 -5 91 64 77 74 103 106 80 99 -5 -2 -353 -4 -775 -5z",
    stroke: "#000000",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20786 20033 c-45 -43 -58 -60 -37 -47 25 15 121 115 109 114 -2 -1 -34 -31 -72 -67z",
    stroke: "#000000",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19473 19973 c115 -2 299 -2 410 0 111 1 18 2 -208 2 -225 0 -316 -1 -202 -2z",
    stroke: "#000000",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20199 19554 l-124 -124 -1470 0 c-850 0 -1476 -4 -1484 -9 -11 -7 -7 -14 19 -30 78 -47 53 -46 1480 -46 1244 0 1350 1 1407 17 114 32 228 105 275 176 26 39 45 126 30 136 -4 3 -64 -51 -133 -120z",
    stroke: "#000000",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12287 19423 c-4 -3 -7 -24 -7 -45 0 -24 -7 -45 -19 -57 -18 -18 -17 -19 48 -25 36 -3 354 -6 706 -6 l641 0 69 70 69 70 -74 0 c-62 0 -85 -5 -130 -28 l-55 -27 -535 -3 c-522 -3 -600 -1 -629 18 -12 7 -12 11 -2 24 12 14 8 16 -31 16 -25 0 -48 -3 -51 -7z",
    stroke: "#000000",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12798 19423 c101 -2 263 -2 360 0 97 1 15 2 -183 2 -198 0 -278 -1 -177 -2z",
    stroke: "#000000",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23737 19423 c-4 -3 -7 -24 -7 -45 0 -24 -7 -45 -19 -57 -18 -18 -17 -19 42 -25 33 -3 349 -6 701 -6 l642 0 69 70 69 70 -74 0 c-62 0 -85 -5 -130 -28 l-55 -27 -548 -3 c-580 -3 -634 1 -622 39 5 16 1 19 -28 19 -18 0 -37 -3 -40 -7z",
    stroke: "#000000",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24238 19423 c101 -2 263 -2 360 0 97 1 15 2 -183 2 -198 0 -278 -1 -177 -2z",
    stroke: "#000000",
    strokeWidth: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmuglergods);
export default __webpack_public_path__ + "static/media/smuglergods.7c4a11c2f765f9a2e84f132aa98034e7.svg";
export { ForwardRef as ReactComponent };